import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InvestmentProgramRestoreDto } from "../models/InvestmentProgram";

interface IpStatusState {
  hasInvalidIp: boolean;
  ipStatusInfo: InvestmentProgramRestoreDto | null;
}

const initialState: IpStatusState = {
  hasInvalidIp: false,
  ipStatusInfo: null,
};

const ipStatusSlice = createSlice({
  name: 'ipStatus',
  initialState,
  reducers: {
    setHasInvalidIp(state, action: PayloadAction<boolean>) {
      state.hasInvalidIp = action.payload;
    },
    setIpStatusInfo(state, action: PayloadAction<InvestmentProgramRestoreDto | null>) {
      state.ipStatusInfo = action.payload;
    },
  },
});

export const { setHasInvalidIp, setIpStatusInfo } = ipStatusSlice.actions;

export default ipStatusSlice.reducer;

export const selectHasInvalidIp = (state: any) => state.ipStatus.hasInvalidIp;
export const selectIpStatusInfo = (state: any) => state.ipStatus.ipStatusInfo;
